import View from './view';
export const Markdown = View;
